import { Trans } from 'react-i18next';
import { Link } from '@material-ui/core';
import { EmbeddedNotificationWrapper } from '../EmbeddedNotificationWrapper/EmbeddedNotificationWrapper';
import i18next from 'i18next';
import { EmbeddedNotificationType } from '@signaturit/react-components-library';
import { UserFixedNotificationsFlow } from '../../../constants/UserFixedNotificationsFlow';
import React from 'react';

export const getPendingConfirmationNotificationTemplate = (classes: {
    embeddedNotificationWrapper: string;
    warningLink: string;
}) => {
    const onClickHandler = () => {
        window.location.reload();
    };

    const body = (
        <Trans
            i18nKey={'default._notifications.payment_confirmation_content'}
            components={[
                <Link
                    data-signa={`link-action-${UserFixedNotificationsFlow.pendingConfirmation}`}
                    className={classes.warningLink}
                    underline="always"
                    onClick={onClickHandler}
                />,
            ]}
        />
    );
    return (
        <div className={classes.embeddedNotificationWrapper}>
            <EmbeddedNotificationWrapper
                title={i18next.t('default._notifications.payment_confirmation_title')}
                body={body}
                type={EmbeddedNotificationType.warning}
                name={UserFixedNotificationsFlow.pendingConfirmation}
            />
        </div>
    );
};
export const getPaymentFailureNotificationTemplate = (
    classes: {
        embeddedNotificationWrapper: string;
        linkStyle: string;
    },
    remainingChargeAttempts: number = 7
) => {
    const SUBSCRIPTION_LINK = '#/subscription/billing';
    const body = (
        <Trans
            i18nKey={'default._notifications.payment_failure_content'}
            values={{
                days: remainingChargeAttempts,
            }}
            components={[
                <Link
                    data-signa={`link-action-${UserFixedNotificationsFlow.paymentFailure}`}
                    className={classes.linkStyle}
                    underline="always"
                    target="_self"
                    href={SUBSCRIPTION_LINK}
                />,
            ]}
        />
    );
    return (
        <div className={classes.embeddedNotificationWrapper}>
            <EmbeddedNotificationWrapper
                title={i18next.t('default._notifications.payment_failure_title')}
                body={body}
                type={EmbeddedNotificationType.error}
                name={UserFixedNotificationsFlow.paymentFailure}
            />
        </div>
    );
};
